import React from 'react';

class CartItemQuantity extends React.Component {
   constructor(props){
     super(props);

     this.state = {product_id: this.props.product_id, item_id: this.props.id, calling: false};

     this.state["quantity"] = this.props.quantity;

     this.updateQuantity = this.updateQuantity.bind(this);

     this.spinner = document.getElementById("spinner__container");
   }

   updateQuantity(event){
     var qty = parseInt(event.target.value, 10);
     let subtotalElement = document.getElementById("cart_subtotal");

     var t = this;
     this.setState({quantity: qty });
     var up_data = {update_cart_item_form: t.state};
     up_data.update_cart_item_form.quantity = qty;

     if(t.spinner != null){
       subtotalElement.innerHTML = t.spinner.innerHTML;
     }
     else {
       subtotalElement.innerText = "--";
     }

     $.ajax({
       url: Routes.update_cart_item_path({ id: t.state.item_id, format: "json" }),
 type: 'PUT',
     contentType: 'application/json',
     data: JSON.stringify(up_data),
     dataType: 'json',
       success: function(data){
         update_cart_item_quantity(data.cart.item_count);
         if(t.reloadConditions(qty)){
           location.reload(true);
         }
         else{
           subtotalElement.innerText = data.cart_total;
         }
       }
     });
   }

  reloadConditions(qty){
    if(this.props.bulk_prices === true){
      return true;
    }

    return ( qty === 0 
      || qty > this.props.max_allowed_quantity 
      || qty > this.props.product_quantity
      || (this.props.product_quantity <= 0));
  }
  quantityValues(){
    var vals = new Array();
    var q_base = 0;
    while(q_base <=  (this.state.quantity + 10) ){
      vals.push(q_base);
      q_base += 1;
    }
    return vals;
  }

  render(){
    var qty_values = this.quantityValues().map(function (q) {
      return (<option key={q} value={q}>{q}</option>);
    });

    return (
      <select onChange={this.updateQuantity} value={this.state.quantity} className="form-control cart-quantity-field">
      {qty_values}
      </select>
    );
  }

}

export default CartItemQuantity;

// document.addEventListener('DOMContentLoaded', () => {
//   ReactDOM.render(
//     <CartItemQuantity product_id="1"
//     item_id="1" quantity="5"/>,
//     document.body.appendChild(document.createElement('div')),
//   )
// })



// WEBPACK FOOTER //
// ./app/javascript/store_front/app/components/cart_item_quantity.jsx